import React from 'react';
import { Link } from 'react-router-dom';
import { Cpu, Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram, ArrowUp, Contact } from 'lucide-react';
import Services from '../../pages/public/Services/Services';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const footerLinks = {
    Services: [
      { name: 'Hardware Solution', path: '/Services' },
      { name: 'Software Solution', path: '/Services' },
      { name: 'Support & Consulting', path: '/Services' },
      { name: 'Expert Solution', path: '/Services' },
    ],
    Product: [
      { name: 'Power Monitoring', path: '/products/sensor-network' },
      { name: 'Fleet Track', path: '/products/asset-security' },
      { name: 'Smart track', path: 'products/fleet-track' },
      { name: 'Sensor Network', path: '/products/ble-network' },
    ],
    Contact: [
      { name: 'Contact Us', path: '/contact' },
      { name: 'FAQ', path: '/contact' },
      { name: 'Support Center', path: '/contact' },
    ],
  };

  // ✅ SET YOUR REAL SOCIAL MEDIA URLS HERE
  const socialLinks = [
    { icon: Facebook, url: 'https://facebook.com/YOUR_PAGE' },
    { icon: Twitter, url: 'https://twitter.com/YOUR_HANDLE' },
    { icon: Linkedin, url: 'https://linkedin.com/company/YOUR_COMPANY' },
    { icon: Instagram, url: 'https://instagram.com/YOUR_HANDLE' },
  ];

  return (
    <footer 
      /* CHANGED: background to gray + sky blue gradient */
     className="bg-gradient-to-b from-gray-200 via-gray-200 to-sky-100 text-gray-400 pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">

          {/* Brand */}
          <div className="lg:col-span-2">
            <Link
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex items-center space-x-3 mb-6"
            >
              
              {/* CHANGED: icon background to cool gray */}
              <div className="w-12 h-12 bg-gray-300 rounded-xl flex items-center justify-center">
                <Cpu className="w-7 h-7 text-gray-700" />
              </div>

              <div>
                <span className="text-xl font-bold text-gray-900">SRISHTI WIRELESS</span>
                <span className="block text-xs text-gray-500">SOLUTIONS</span>
              </div>
            </Link>

            <p className="text-gray-600 mb-6 max-w-sm">
              Leading provider of IoT and embedded solutions for smart industries.
              Transforming businesses with cutting-edge connected technology.
            </p>

            <div className="flex space-x-4">
              {socialLinks.map(({ icon: Icon, url }, idx) => (
                <a
                  key={idx}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"

                  /* CHANGED: icon circle gray + sky hover */
                  className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 hover:bg-sky-300 hover:text-black transition-all duration-300"
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-lg font-semibold mb-4 capitalize text-gray-900">
                {title}
              </h3>

              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}

                      /* CHANGED: hover color sky tone */
                      className="text-gray-600 hover:text-sky-600 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

        </div>

        {/* CHANGED: Contact Info (left) + Copyright & scroll-to-top (right) combined into one row */}
        <div className="border-t border-gray-500 pt-8 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">

          {/* Contact Info - left side */}
          <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:gap-8">

            <div className="flex items-center space-x-3 text-gray-600">
              <MapPin className="w-5 h-5 text-sky-600" />
              <span>301,De-Elmas, Sonawala Road, Goregaon(East), Mumbai-400063</span>
            </div>

            <div className="flex items-center space-x-3 text-gray-600">
              <Phone className="w-5 h-5 text-sky-600" />
              <span>+91 9833916981</span>
            </div>

            <div className="flex items-center space-x-3 text-gray-600">
              <Mail className="w-5 h-5 text-sky-600" />
              <span>sales@siwi.in</span>
            </div>

          </div>

          {/* Copyright + scroll-to-top - right side */}
          <div className="flex items-center space-x-6 text-sm text-gray-500">
            <p className="text-gray-500 text-sm whitespace-nowrap">
              Srishti Wireless Solution © {new Date().getFullYear()} All rights reserved.
            </p>

            <button
              onClick={scrollToTop}

              /* CHANGED: button gray + sky hover */
              className="w-10 h-10 rounded-full bg-gray-400 hover:bg-sky-500 flex items-center justify-center text-white transition-colors shrink-0"
            >
              <ArrowUp className="w-5 h-5" />
            </button>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;